export const QuoteSelectionSummary = ({ items }) => {
  if (!items.length) return null;
  const quantity = items.reduce((sum, item) => sum + Number(item.quantity || 1), 0);

  return (
    <section className="px-6 md:px-8 py-6 border-b border-brand-green/15" data-testid="quote-selection-summary">
      <h4 className="text-[0.62rem] tracking-[0.28em] uppercase text-brand-ink/60 mb-3" data-testid="quote-selection-count">
        Your selection · {quantity} door{quantity === 1 ? "" : "s"}
      </h4>
      <ul className="max-h-64 overflow-y-auto divide-y divide-brand-green/10" tabIndex={0} aria-label="Selected doors" data-testid="quote-selection-list">
        {items.map((item, index) => {
          const id = item._uid || `selection-${index}`;
          const name = item.panel_style || item.name || "Custom Door";
          return (
            <li key={id} className="flex items-start gap-3 py-3" data-testid={`quote-selection-${id}`}>
              {item.image && (
                <img src={item.image} alt={name} className="w-12 h-16 shrink-0 object-contain bg-brand-bone-2" data-testid={`quote-selection-image-${id}`} />
              )}
              <div className="min-w-0 flex-1 [overflow-wrap:anywhere]">
                <div className="text-sm text-brand-green font-medium" data-testid={`quote-selection-name-${id}`}>{name}</div>
                <div className="mt-1 text-xs text-brand-ink/65" data-testid={`quote-selection-specs-${id}`}>
                  {[item.series, item.finish, item.door_type].filter(Boolean).join(" · ")}
                </div>
                <div className="mt-1 text-xs text-brand-ink/65" data-testid={`quote-selection-size-${id}`}>
                  {item.width || "—"} × {item.height || "—"} · Qty {item.quantity || 1}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
};